import Circle from "../LogoSVG/Circle";
import Arrow from "../LogoSVG/Arrow";
import { listTech } from "./TeknikDesktop";

function OptimizerMobile() {
  return (
    <a className="" href="https://www.teknixcorp.com/" target="_blank">
      <div className=" text-gray-4 mb-1.5 text-[15px]">Apr 2022 - Jul 2022</div>

      <div className="mb-2">
        <a
          className="block font-medium mb-2"
          href="https://www.teknixcorp.com/"
          target="_blank"
        >
          Software Developer Intern
          <Circle className="mx-1.5 h-1 w-1 inline align-middle" />
          TekNix{" "}
          <span className="whitespace-nowrap">
            Corporation <Arrow className="inline align-middle" />
          </span>
        </a>
      </div>

      <div className="text-gray-5 text-[16px]">
        <div className="flex flex-row items-start mb-2">
          <span>
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
          </span>
          <div className="text-gray-4 ">
            Contributed to smart contract development and blockchain integration
            for game management, network interactions, and crypto wallet
            connectivity
          </div>
        </div>
      </div>
    </a>
  );
}

export default OptimizerMobile;
